<template>
  <div></div>
</template>

<script>
  export default {
    props: {
      value: {
        type: null,
        default: null
      }
    },

    data() {
      return {
        localData: null
      }
    },

    created() {
      this.localData = this.value
    },
    methods: {}
  }
</script>

<style lang="scss" scoped></style>
